exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.filter_heading[data-v-92578204] {\n  font-weight: bold;\n}\n.filter_sub[data-v-92578204] {\n  margin-left: 10px;\n  color: black;\n  font-weight:390;\n  padding :0\n}\n", ""]);
